import React from "react"

import { ReactComponent as HeartSVG } from "../../../../../assets/svg/suits/heart.svg"
import { ReactComponent as ClubSVG } from "../../../../../assets/svg/suits/club.svg"
import { ReactComponent as DiamondSVG } from "../../../../../assets/svg/suits/diamond.svg"
import { ReactComponent as SpadeSVG } from "../../../../../assets/svg/suits/spades.svg"
import { colors } from "../../../../../lib/colors"

export const SUITS = [
  {
    name: "R",
    icon: "Red",
    color: colors.secondaryText,
    width: "142px",
  },
  {
    name: "B",
    icon: "Black",
    color: colors.secondaryBackground,
    width: "142px",
  },
  {
    name: "H",
    icon: <HeartSVG />,
    color: colors.secondaryText,
  },
  {
    name: "D",
    icon: <DiamondSVG />,
    color: colors.secondaryText,
  },
  {
    name: "S",
    icon: <SpadeSVG />,
    color: colors.secondaryBackground,
  },
  {
    name: "C",
    icon: <ClubSVG />,
    color: colors.secondaryBackground,
  },
]
